import { useEffect, useState } from 'react';
import { Badge, useToast } from '@chakra-ui/react';

const copyToClipboard = (text: string) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text);
  } else {
    const ta = document.createElement('textarea');
    ta.value = text;
    ta.style.position = 'fixed';
    ta.style.opacity = '0';
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    document.body.removeChild(ta);
  }
};

export const DevSectionBadges = () => {
  const [sections, setSections] = useState<{id: string, top: number, right: number}[]>([]);
  const toast = useToast();

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') return;
    const update = () => {
      const els = document.querySelectorAll('[id$=-section]');
      setSections(Array.from(els).map(el => {
        const r = el.getBoundingClientRect();
        return { id: el.id, top: r.top + window.scrollY + 8, right: 8 };
      }));
    };
    update();
    window.addEventListener('scroll', update);
    window.addEventListener('resize', update);
    return () => { window.removeEventListener('scroll', update); window.removeEventListener('resize', update); };
  }, []);

  if (process.env.NODE_ENV !== 'development') return null;

  return (
    <>
      {sections.map(s => (
        <Badge
          key={s.id}
          position="absolute"
          top={s.top + 'px'}
          right={s.right + 'px'}
          zIndex={9999}
          colorScheme="purple"
          cursor="pointer"
          fontSize="xs"
          px={2}
          py={1}
          onClick={() => {
            copyToClipboard('#' + s.id);
            toast({ title: 'Copied: #' + s.id, status: 'success', duration: 1500, position: 'bottom' });
          }}
          _hover={{ transform: 'scale(1.05)', bg: 'purple.500' }}
          borderRadius="md"
          boxShadow="md"
        >
          #{s.id}
        </Badge>
      ))}
    </>
  );
};
